// M8: Canvas snapshot (PNG). Lands in Sprint 4.
import type { SceneConfig } from '@app-types/scene';

const FILENAME_SAFE_RE = /[^\w\u4e00-\u9fa5-]+/g;

export function buildSnapshotFilename(sceneConfig: SceneConfig | null): string {
  const source = sceneConfig?.name || sceneConfig?.id || 'mindcloudxai-scene';
  const name = source
    .trim()
    .replace(FILENAME_SAFE_RE, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');

  // 严格按 {场景名称}_{YYYYMMDD}_{HHmmss}.png 命名
  const now = new Date();
  const date = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('');
  const time = [
    String(now.getHours()).padStart(2, '0'),
    String(now.getMinutes()).padStart(2, '0'),
    String(now.getSeconds()).padStart(2, '0'),
  ].join('');

  return `${name || 'mindcloudxai-scene'}_${date}_${time}.png`;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
